/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsDeleteDesktopModel,
  IChatsDeleteDesktopRequest,
  IMappers,
  IChatsDeleteDesktopResponse,
  IChatsDeleteDesktopResponseError,
  TChatsDeleteDesktopResponse,
} from './types';

const defaultConfig: TChatsDeleteDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/delete-desktop/',
  hostType: 'api',
} as TChatsDeleteDesktopModel;

function createChatsDeleteDesktopModel(parameters: IChatsDeleteDesktopRequest): TChatsDeleteDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsDeleteDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsDeleteDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsDeleteDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsDeleteDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsDeleteDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsDeleteDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsDeleteDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsDeleteDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsDeleteDesktopResponse;
}

export { defaultConfig, createChatsDeleteDesktopModel, fetchChatsDeleteDesktop };
